import CurrentEquipmentPageMobile from "./CurrentEquipmentPageMobile";

export default CurrentEquipmentPageMobile;
